<template>
  <div>
    <div v-if="justView || addQuestionTemplate === 'default'" class="row">
      <div
        class="col-xl-3 mt-auto mb-auto text"
        :style="{
          color: textColor || '#000000',
        }"
      >
        <span :class="`${this.$route.fullPath.includes('treatments') ? 'text-addquestion' : ''}`"> {{ text }} </span>
      </div>
      <template
        v-if="
          colorTemplate === 'colors' ||
          colorTemplate.includes('#') ||
          (colorTemplate === 'gray-scale' && metric === 'nps-0-10') ||
          colorTemplate === 'fixedColors' ||
          metric === 'nps-1-5'
        "
      >
        <div
          v-if="justView"
          :class="`col-xl-${
            configAction ? '12' : '9'
          } mt-auto mb-auto applicabled`"
        >
          <div
            class="likert"
            :style="`display: ${
              configAction ? 'table-cel' : 'flex'
            }; justify-content: ${configAction ? '' : 'flex-end'}`"
          >
            <span
              class="btn btn-sm"
              :class="
                justView && selected === 1
                  ? 'btn-likert-selected-1'
                  : 'btn-likert-view'
              "
            >
              {{ returnTextButton1(lang, template) }}
            </span>

            <span
              class="btn btn-sm btn-likert-view"
              :class="
                justView && selected === 2
                  ? 'btn-likert-selected-2'
                  : 'btn-likert-view'
              "
            >
              {{ returnTextButton2(lang, template) }}
            </span>

            <span
              class="btn btn-sm btn-likert-view"
              :class="
                justView && selected === 3
                  ? 'btn-likert-selected-3'
                  : 'btn-likert-view'
              "
            >
              {{ returnTextButton3(lang, template) }}
            </span>

            <span
              class="btn btn-sm btn-likert-view"
              :class="
                justView && selected === 4
                  ? 'btn-likert-selected-4'
                  : 'btn-likert-view'
              "
            >
              {{ returnTextButton4(lang, template) }}
              </span
            >

            <span
              class="btn btn-sm btn-likert-view"
              :class="
                justView && selected === 5
                  ? 'btn-likert-selected-5'
                  : 'btn-likert-view'
              "
            >
              {{ returnTextButton5(lang, template) }}
              </span
            >

            <applicable
              style="margin-top: -15px;"
              v-if="reviewAnswer === -1"
              :justView="justView"
              :itemId="index"
            />
          </div>
        </div>
        <div
          v-else
          :class="`col-xl-${
            configAction ? '12' : '9'
          } mt-auto mb-auto applicabled`"
        >
          <div
            :class="`${configAction ? '' : 'likert'}`"
            :style="`display: ${
              configAction ? 'table-cel' : 'flex'
            }; justify-content: ${configAction ? '' : 'flex-end'}`"
          >
            <button
              class="btn btn-sm btn-likert-1"
              :class="`item-likert-${itemId} ${
                selected === 1 ? 'active' : ''
              } ${configAction ? 'width-btn' : ''}`"
              @click="setReview($event, itemId, 1)"
            >
              {{ returnTextButton1(lang, template) }}
            </button>

            <button
              class="btn btn-sm btn-likert-2"
              :class="`item-likert-${itemId} ${
                selected === 2 ? 'active' : ''
              } ${configAction ? 'width-btn' : ''}`"
              @click="setReview($event, itemId, 2)"
            >
              {{ returnTextButton2(lang, template) }}
            </button>

            <button
              class="btn btn-sm btn-likert-3"
              :class="`item-likert-${itemId} ${
                selected === 3 ? 'active' : ''
              } ${configAction ? 'width-btn' : ''}`"
              @click="setReview($event, itemId, 3)"
            >
              {{ returnTextButton3(lang, template) }}
            </button>

            <button
              class="btn btn-sm btn-likert-4"
              :class="`item-likert-${itemId} ${
                selected === 4 ? 'active' : ''
              } ${configAction ? 'width-btn' : ''}`"
              @click="setReview($event, itemId, 4)"
            >
              {{ returnTextButton4(lang, template) }}
            </button>

            <button
              class="btn btn-sm btn-likert-5"
              :class="`item-likert-${itemId} ${
                selected === 5 ? 'active' : ''
              } ${configAction ? 'width-btn' : ''}`"
              @click="setReview($event, itemId, 5)"
            >
              {{ returnTextButton5(lang, template) }}
            </button>

            <applicable
              style="margin-top: -15px; width: 100%;"
              v-if="applicableEnabled"
              :itemId="index"
              v-model="applicabled"
              :selectedButton="selectedButton"
              @click.native="selectedButton = !selectedButton"
              :btnBlock="true"
              :lang="lang"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="justView" class="col-xl-7 mt-auto mb-auto applicabled">
          <div :class="`${configAction ? '' : 'likert'}`">
            <span
              class="btn btn-sm"
              :class="
                justView && selected === 1
                  ? 'btn-likert-selected-1'
                  : 'btn-likert-view'
              "
            >
              {{ returnTextButton1(lang, template) }}
            </span>

            <span
              class="btn btn-sm btn-likert-view"
              :class="
                justView && selected === 2
                  ? 'btn-likert-selected-2'
                  : 'btn-likert-view'
              "
            >
              {{ returnTextButton2(lang, template) }}
              </span
            >

            <span
              class="btn btn-sm btn-likert-view"
              :class="
                justView && selected === 3
                  ? 'btn-likert-selected-3'
                  : 'btn-likert-view'
              "
            >
              {{ returnTextButton3(lang, template) }}
              </span
            >

            <span
              class="btn btn-sm btn-likert-view"
              :class="
                justView && selected === 4
                  ? 'btn-likert-selected-4'
                  : 'btn-likert-view'
              "
              >
              {{ returnTextButton4(lang, template) }}
              </span
            >

            <span
              class="btn btn-sm btn-likert-view"
              :class="
                justView && selected === 5
                  ? 'btn-likert-selected-5'
                  : 'btn-likert-view'
              "
              >
              {{ returnTextButton5(lang, template) }}
              </span
            >
          </div>

          <applicable
            v-if="applicableEnabled"
            :itemId="index"
            :selectedButton="selectedButton"
            v-model="applicabled"
            @click.native="selectedButton = !selectedButton"
            :btnBlock="true"
          />
        </div>
        <div v-else class="col-xl-7 mt-auto mb-auto applicabled">
          <div :class="`${configAction ? '' : 'likert'}`">
            <button
              class="btn btn-sm hover btn-likert-no-color-1"
              :class="`item-likert-${itemId} ${selected === 1 ? 'active' : ''}`"
              @click="setReview($event, itemId, 1)"
            >
              {{ returnTextButton1(lang, template) }}
            </button>

            <button
              class="btn btn-sm btn-likert-no-color-2"
              :class="`item-likert-${itemId} ${selected === 2 ? 'active' : ''}`"
              @click="setReview($event, itemId, 2)"
            >
              {{ returnTextButton2(lang, template) }}
            </button>

            <button
              class="btn btn-sm btn-likert-no-color-3"
              :class="`item-likert-${itemId} ${selected === 3 ? 'active' : ''}`"
              @click="setReview($event, itemId, 3)"
            >
              {{ returnTextButton3(lang, template) }}
            </button>

            <button
              class="btn btn-sm btn-likert-no-color-4"
              :class="`item-likert-${itemId} ${selected === 4 ? 'active' : ''}`"
              @click="setReview($event, itemId, 4)"
            >
              {{ returnTextButton4(lang, template) }}
            </button>

            <button
              class="btn btn-sm btn-likert-no-color-5"
              :class="`item-likert-${itemId} ${selected === 5 ? 'active' : ''}`"
              @click="setReview($event, itemId, 5)"
            >
              {{ returnTextButton5(lang, template) }}
            </button>
          </div>

          <applicable
            v-if="applicableEnabled"
            :itemId="index"
            :selectedButton="selectedButton"
            v-model="applicabled"
            @click.native="selectedButton = !selectedButton"
            :btnBlock="true"
            :lang="lang"
          />
        </div>
      </template>
    </div>

    <div v-else>
      <div class="row">
        <div
          class="col-xl-12 mt-auto mb-auto text"
          style="display: flex; align-items: center; justify-content: center;"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ text }}
        </div>
        <template
          v-if="
            colorTemplate === 'colors' ||
            colorTemplate.includes('#') ||
            (colorTemplate === 'gray-scale' && metric === 'nps-0-10') ||
            metric === 'nps-1-5'
          "
        >
          <div v-if="justView" class="col-xl-8 mt-auto mb-auto applicabled">
            <div
              :class="`${configAction ? '' : 'likert'}`"
              style="display: flex; justify-content: flex-end;"
            >
              <span
                class="btn btn-sm"
                :class="
                  justView && selected === 1
                    ? 'btn-likert-selected-1'
                    : 'btn-likert-view'
                "
                >
                {{ returnTextButton1(lang, template) }}
              </span>

              <span
                class="btn btn-sm btn-likert-view"
                :class="
                  justView && selected === 2
                    ? 'btn-likert-selected-2'
                    : 'btn-likert-view'
                "
                >
                {{ returnTextButton2(lang, template) }}
              </span>

              <span
                class="btn btn-sm btn-likert-view"
                :class="
                  justView && selected === 3
                    ? 'btn-likert-selected-3'
                    : 'btn-likert-view'
                "
              >
                {{ returnTextButton3(lang, template) }}
              </span>

              <span
                class="btn btn-sm btn-likert-view"
                :class="
                  justView && selected === 4
                    ? 'btn-likert-selected-4'
                    : 'btn-likert-view'
                "
                >
                {{ returnTextButton4(lang, template) }}
                </span
              >

              <span
                class="btn btn-sm btn-likert-view"
                :class="
                  justView && selected === 5
                    ? 'btn-likert-selected-5'
                    : 'btn-likert-view'
                "
                >
                {{ returnTextButton5(lang, template) }}
                </span
              >

              <applicable
                style="margin-top: -15px;"
                class="applicable-big"
                v-if="reviewAnswer === -1"
                :justView="justView"
                :itemId="index"
              />
            </div>
          </div>
          <div v-else class="col-xl-12 mt-auto mb-auto applicabled">
            <div class="align-center-big">
              <button
                class="btn btn-sm btn-likert-1 btn-big"
                :class="`item-likert-${itemId} ${
                  selected === 1 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 1)"
              >
                {{ returnTextButton1(lang, template) }}
              </button>

              <button
                class="btn btn-sm btn-likert-2 btn-big"
                :class="`item-likert-${itemId} ${
                  selected === 2 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 2)"
              >
                {{ returnTextButton2(lang, template) }}
              </button>

              <button
                class="btn btn-sm btn-likert-3 btn-big"
                :class="`item-likert-${itemId} ${
                  selected === 3 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 3)"
              >
                {{ returnTextButton3(lang, template) }}
              </button>

              <button
                class="btn btn-sm btn-likert-4 btn-big"
                :class="`item-likert-${itemId} ${
                  selected === 4 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 4)"
              >
                {{ returnTextButton4(lang, template) }}
              </button>

              <button
                class="btn btn-sm btn-likert-5 btn-big"
                :class="`item-likert-${itemId} ${
                  selected === 5 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 5)"
              >
                {{ returnTextButton5(lang, template) }}
              </button>

              <applicable
                style="margin-top: -15px;"
                class="applicable-big"
                v-if="applicableEnabled"
                :itemId="index"
                v-model="applicabled"
                :selectedButton="selectedButton"
                @click.native="selectedButton = !selectedButton"
                :btnBlockLikert="true"
                :lang="lang"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="justView" class="col-xl-7 mt-auto mb-auto applicabled">
            <div :class="`${configAction ? '' : 'likert'}`">
              <span
                class="btn btn-sm"
                :class="
                  justView && selected === 1
                    ? 'btn-likert-selected-1'
                    : 'btn-likert-view'
                "
                >
                {{ returnTextButton1(lang, template) }}
              </span>

              <span
                class="btn btn-sm btn-likert-view"
                :class="
                  justView && selected === 2
                    ? 'btn-likert-selected-2'
                    : 'btn-likert-view'
                "
              >
                {{ returnTextButton2(lang, template) }}
              </span>

              <span
                class="btn btn-sm btn-likert-view"
                :class="
                  justView && selected === 3
                    ? 'btn-likert-selected-3'
                    : 'btn-likert-view'
                "
              >
                {{ returnTextButton3(lang, template) }}
              </span>

              <span
                class="btn btn-sm btn-likert-view"
                :class="
                  justView && selected === 4
                    ? 'btn-likert-selected-4'
                    : 'btn-likert-view'
                "
                >
                {{ returnTextButton4(lang, template) }}
                </span
              >

              <span
                class="btn btn-sm btn-likert-view"
                :class="
                  justView && selected === 5
                    ? 'btn-likert-selected-5'
                    : 'btn-likert-view'
                "
                >
                {{ returnTextButton5(lang, template) }}
                </span
              >
            </div>

            <applicable
              v-if="applicableEnabled"
              :itemId="index"
              :selectedButton="selectedButton"
              v-model="applicabled"
              @click.native="selectedButton = !selectedButton"
            />
          </div>
          <div v-else class="col-xl-7 mt-auto mb-auto applicabled">
            <div :class="`${configAction ? '' : 'likert'}`">
              <button
                class="btn btn-sm hover btn-likert-no-color-1"
                :class="`item-likert-${itemId} ${
                  selected === 1 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 1)"
              >
                {{ returnTextButton1(lang, template) }}
              </button>

              <button
                class="btn btn-sm btn-likert-no-color-2"
                :class="`item-likert-${itemId} ${
                  selected === 2 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 2)"
              >
                {{ returnTextButton2(lang, template) }}
              </button>

              <button
                class="btn btn-sm btn-likert-no-color-3"
                :class="`item-likert-${itemId} ${
                  selected === 3 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 3)"
              >
                {{ returnTextButton3(lang, template) }}
              </button>

              <button
                class="btn btn-sm btn-likert-no-color-4"
                :class="`item-likert-${itemId} ${
                  selected === 4 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 4)"
              >
                {{ returnTextButton4(lang, template) }}
              </button>

              <button
                class="btn btn-sm btn-likert-no-color-5"
                :class="`item-likert-${itemId} ${
                  selected === 5 ? 'active' : ''
                }`"
                @click="setReview($event, itemId, 5)"
              >
                {{ returnTextButton5(lang, template) }}
              </button>
            </div>

            <applicable
              v-if="applicableEnabled"
              class="applicable-big"
              :itemId="index"
              :selectedButton="selectedButton"
              v-model="applicabled"
              @click.native="selectedButton = !selectedButton"
              :lang="lang"
            />
          </div>
        </template>
      </div>
    </div>

    <comment-area
      :clickButton="expandComment"
      :template="addQuestionTemplate"
      v-if="commentEnabled && !justView"
      v-model="comment"
    />

    <p
      v-if="hasComment && justView"
      class="comment-area"
      :style="{
        color: textColor || '#000000',
      }"
    >
      Comentário: {{ hasComment }}
    </p>

    <hr />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import commentArea from '../comment-area';
import applicable from '../applicable';

export default {
  name: 'likertScale',

  components: {
    commentArea,
    applicable,
  },

  props: {
    textColor: { type: String, required: false },
    text: { type: String, required: false },
    itemId: { type: String, required: false },
    index: { type: Number, required: false },
    justView: { type: Boolean, default: false },
    selected: { type: Number },
    colorTemplate: { type: String, required: false, default: 'colors' },
    commentEnabled: { type: Boolean, default: false },
    applicableEnabled: { type: Boolean, default: false },
    hasComment: { type: String, default: null },
    reviewAnswer: { type: Number, required: false },
    addQuestionTemplate: { type: String, required: false, default: 'default' },
    idQuestion: { type: String, required: false },
    lang: { type: String, required: false, default: 'br' },
    template: { type: String, required: false, default: 'satisfaction' },
    configAction: { type: Boolean, required: false },
  },
  data: () => ({
    position: null,
    metric: null,
    review: null,
    comment: null,
    applicabled: null,
    selectedButton: false,
    buttons: null,
    expandComment: false,
  }),
  watch: {
    comment: function watchComment() {
      this.update();
    },
    applicabled: function watchApplicated(value) {
      this.$emit('input', {
        review: value,
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
    selectedButton: function watchSelectedButton(value) {
      if (value) {
        this.selectedButton = true;
        if (this.buttons) {
          this.buttons.forEach((element) => {
            element.classList.remove('active');
          });
        }

        this.$emit('input', {
          review: -1,
          comment: this.comment,
          position: this.itemId,
          _id: this.idQuestion,
        });
      } else if (this.grade !== this.review) {
        event.target.classList.add('active');
        this.review = this.grade;
      }
    },
    review: function watchReview(value) {
      if (value) {
        this.expandComment = true;
        this.review = value;
      } else {
        this.expandComment = false;
      }
    },
  },
  methods: {
    setReview(event, clazz, grade) {
      const $elements = document.querySelectorAll(`.item-likert-${clazz}`);

      this.buttons = $elements;

      $elements.forEach((element) => {
        element.classList.remove('active');
      });

      if (grade !== this.review) {
        event.target.classList.add('active');
        this.review = grade;
      } else {
        this.review = null;
      }

      this.update();
    },

    update() {
      this.selectedButton = false;

      this.$emit('input', {
        review: this.review,
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },

    returnTextButton1(lang, template) {
      if (template === 'satisfaction') {
        if (lang === 'br') {
          return 'Muito insatisfeito';
        } else if (lang === 'us') {
          return 'Very unsatisfied';
        }
        return 'Muy insatisfecho';
      } else if (template === 'agreement') {
        if (lang === 'br') {
          return 'Discordo totalmente';
        } else if (lang === 'us') {
          return 'Totally disagree';
        }
        return 'Totalmente en desacuerdo';
      } else if (template === 'frequency') {
        if (lang === 'br') {
          return 'Nunca';
        } else if (lang === 'us') {
          return 'Never';
        }
        return 'Nunca';
      } else if (template === 'importance') {
        if (lang === 'br') {
          return 'Não é importante';
        } else if (lang === 'us') {
          return 'Its not important';
        }
        return 'No es importante';
      } else if (template === 'probability') {
        if (lang === 'br') {
          return 'Quase sempre falso';
        } else if (lang === 'us') {
          return 'Almost always fake';
        }
        return 'Casi siempre falso';
      }

      if (lang === 'br') {
        return 'Muito insatisfeito';
      } else if (lang === 'us') {
        return 'Very unsatisfied';
      }
      return 'Muy insatisfecho';
    },

    returnTextButton2(lang, template) {
      if (template === 'satisfaction') {
        if (lang === 'br') {
          return 'Insatisfeito';
        } else if (lang === 'us') {
          return 'Unsatisfied';
        }
        return 'Insatisfecho';
      } else if (template === 'agreement') {
        if (lang === 'br') {
          return 'Discordo';
        } else if (lang === 'us') {
          return 'Disagree';
        }
        return 'Desacuerdo';
      } else if (template === 'frequency') {
        if (lang === 'br') {
          return 'Raramente';
        } else if (lang === 'us') {
          return 'Rarely';
        }
        return 'Casi nunca';
      } else if (template === 'importance') {
        if (lang === 'br') {
          return 'As vezes importante';
        } else if (lang === 'us') {
          return 'Sometimes important';
        }
        return 'A veces importante';
      } else if (template === 'probability') {
        if (lang === 'br') {
          return 'Geralmente falso';
        } else if (lang === 'us') {
          return 'Usually false';
        }
        return 'Generalmente falso';
      }

      if (lang === 'br') {
        return 'Insatisfeito';
      } else if (lang === 'us') {
        return 'Unsatisfied';
      }
      return 'Insatisfecho';
    },

    returnTextButton3(lang, template) {
      if (template === 'satisfaction') {
        if (lang === 'br') {
          return 'Indiferente';
        } else if (lang === 'us') {
          return 'Indifferent';
        }
        return 'Indiferente';
      } else if (template === 'agreement') {
        if (lang === 'br') {
          return 'Não estou decidido';
        } else if (lang === 'us') {
          return 'I am not decided';
        }
        return 'No estoy decidido';
      } else if (template === 'frequency') {
        if (lang === 'br') {
          return 'Ocasionalmente';
        } else if (lang === 'us') {
          return 'Occasionally';
        }
        return 'Ocasionalmente';
      } else if (template === 'importance') {
        if (lang === 'br') {
          return 'Moderado';
        } else if (lang === 'us') {
          return 'Moderate';
        }
        return 'Moderado';
      } else if (template === 'probability') {
        if (lang === 'br') {
          return 'As vezes é verdade';
        } else if (lang === 'us') {
          return 'Sometimes it is true';
        }
        return 'A veces es verdad';
      }

      if (lang === 'br') {
        return 'Indiferente';
      } else if (lang === 'us') {
        return 'Indifferent';
      }
      return 'Indiferente';
    },

    returnTextButton4(lang, template) {
      if (template === 'satisfaction') {
        if (lang === 'br') {
          return 'Satisfeito';
        } else if (lang === 'us') {
          return 'Satisfied';
        }
        return 'Satisfecho';
      } else if (template === 'agreement') {
        if (lang === 'br') {
          return 'Concordo';
        } else if (lang === 'us') {
          return 'I agree';
        }
        return 'Estoy de acuerdo';
      } else if (template === 'frequency') {
        if (lang === 'br') {
          return 'Frequentemente';
        } else if (lang === 'us') {
          return 'Often';
        }
        return 'A menudo';
      } else if (template === 'importance') {
        if (lang === 'br') {
          return 'Importante';
        } else if (lang === 'us') {
          return 'Important';
        }
        return 'Importante';
      } else if (template === 'probability') {
        if (lang === 'br') {
          return 'Geralmente verdade';
        } else if (lang === 'us') {
          return 'Usually true';
        }
        return 'Generalmente cierto';
      }

      if (lang === 'br') {
        return 'Satisfeito';
      } else if (lang === 'us') {
        return 'Satisfied';
      }
      return 'Satisfecho';
    },

    returnTextButton5(lang, template) {
      if (template === 'satisfaction') {
        if (lang === 'br') {
          return 'Muito Satisfeito';
        } else if (lang === 'us') {
          return 'Very Satisfied';
        }
        return 'Muy satisfecho';
      } else if (template === 'agreement') {
        if (lang === 'br') {
          return 'Concordo totalmente';
        } else if (lang === 'us') {
          return 'I totally agree';
        }
        return 'Concuerdo totalmente';
      } else if (template === 'frequency') {
        if (lang === 'br') {
          return 'Muito frequente';
        } else if (lang === 'us') {
          return 'Very frequent';
        }
        return 'Muy frecuente';
      } else if (template === 'importance') {
        if (lang === 'br') {
          return 'Muito Importante';
        } else if (lang === 'us') {
          return 'Very important';
        }
        return 'Muy importante';
      } else if (template === 'probability') {
        if (lang === 'br') {
          return 'Quase sempre verdade';
        } else if (lang === 'us') {
          return 'Almost always true';
        }
        return 'Casi siempre cierto';
      }

      if (lang === 'br') {
        return 'Muito Satisfeito';
      } else if (lang === 'us') {
        return 'Very Satisfied';
      }
      return 'Muy satisfecho';
    },
  },
  computed: {
    ...mapState('research', ['likertReview']),
    ...mapState('templates', ['list', 'templateSelected']),
  },
  mounted() {
    this.position = this.$store.state.research.likertControl;
    this.$store.state.research.likertControl += 1;

    this.metric = this.$store.state.actions.action.type;

    const buttonsNotApply = document.querySelectorAll('.applicabled');

    if (this.applicableEnabled) {
      for (let index = 0; index < buttonsNotApply.length; index += 1) {
        buttonsNotApply[index].style.display = 'flex';
      }
    } else {
      for (let index = 0; index < buttonsNotApply.length; index += 1) {
        buttonsNotApply[index].style.display = 'block';
      }
    }

    if (this.$route.name === 'Detalhes da tratativa') {
      for (let index = 0; index < buttonsNotApply.length; index += 1) {
        buttonsNotApply[index].style.display = 'block';
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.align-center-big {
  margin-top: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
}

.applicabled {
  display: flex;
}

.likert {
  padding: 15px 0 10px 0;
  text-align: right;
  width: 100%;
}

.width-btn {
  min-width: 138px;
}

@media only screen and (max-width: 1200px) {
  .applicable-big {
    margin-top: 0px;
    display: flex;
    //align-items: center;
    justify-content: center;
    //margin-left: 65%;
  }

  .btn-big {
    width: 100%;
  }

  .align-center-big {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .text {
    text-align: center;
  }
}
@media only screen and (max-width: 600px) {
  .likert {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    button {
      width: 95%;
    }
    span {
      width: 95%;
    }
  }
}
.btn-likert-view {
  border: 1px solid $gray;
  color: $gray;
}

.btn-big {
  padding-right: 19px;
  padding-left: 19px;
  padding-top: 10px;
  padding-bottom: 10px;
}

// likert pattern
.btn-likert-1 {
  background-color: $white;
  border: 1px solid $grade-zero;
  color: $grade-zero;
  box-shadow: none;
  &:hover {
    background-color: $grade-zero;
    color: $white;
  }
}

.btn-likert-1.active {
  background-color: $grade-zero;
  color: $white;
}

.btn-likert-2 {
  background-color: $white;
  border: 1px solid $grade-two;
  color: $grade-two;
  box-shadow: none;
  &:hover {
    background-color: $grade-two;
    color: $white;
  }
}

.btn-likert-2.active {
  background-color: $grade-two;
  color: $white;
}

.btn-likert-3 {
  background-color: $white;
  border: 1px solid $grade-seven;
  color: $grade-seven;
  box-shadow: none;
  &:hover {
    background-color: $grade-seven;
    color: $white;
  }
}

.btn-likert-3.active {
  background-color: $grade-seven;
  color: $white;
}

.btn-likert-4 {
  background-color: $white;
  border: 1px solid $grade-nine;
  color: $grade-nine;
  &:hover {
    background-color: $grade-nine;
    color: $white;
  }
}

.btn-likert-4.active {
  background-color: $grade-nine;
  color: $white;
}

.btn-likert-5 {
  background-color: $white;
  border: 1px solid $grade-ten;
  color: $grade-ten;
  &:hover {
    background-color: $grade-ten;
    color: $white;
  }
}

.btn-likert-5.active {
  background-color: $grade-ten;
  color: $white;
}

// likert no color
.btn-likert-no-color-1 {
  background-color: $white;
  border: 1px solid $gray;
  color: $gray;
  box-shadow: none;
  &:hover {
    background-color: $grade-zero;
    color: $white;
  }
}

.btn-likert-no-color-1.active {
  background-color: $grade-zero;
  color: $white;
}

.btn-likert-no-color-2 {
  background-color: $white;
  border: 1px solid $gray;
  color: $gray;
  box-shadow: none;
  &:hover {
    background-color: $grade-two;
    color: $white;
  }
}

.btn-likert-no-color-2.active {
  background-color: $grade-two;
  color: $white;
}

.btn-likert-no-color-3 {
  background-color: $white;
  border: 1px solid $gray;
  color: $gray;
  box-shadow: none;
  &:hover {
    background-color: $grade-seven;
    color: $white;
  }
}

.btn-likert-no-color-3.active {
  background-color: $grade-seven;
  color: $white;
}

.btn-likert-no-color-4 {
  background-color: $white;
  border: 1px solid $gray;
  color: $gray;
  &:hover {
    background-color: $grade-nine;
    color: $white;
  }
}

.btn-likert-no-color-4.active {
  background-color: $grade-nine;
  color: $white;
}

.btn-likert-no-color-5 {
  background-color: $white;
  border: 1px solid $gray;
  color: $gray;
  &:hover {
    background-color: $grade-ten;
    color: $white;
  }
}

.btn-likert-no-color-5.active {
  background-color: $grade-ten;
  color: $white;
}

.btn-likert-selected-1 {
  background-color: $grade-zero;
  color: $white;
}

.btn-likert-selected-2 {
  background-color: $grade-two;
  color: $white;
}

.btn-likert-selected-3 {
  background-color: $grade-seven;
  color: $white;
}

.btn-likert-selected-4 {
  background-color: $grade-nine;
  color: $white;
}

.btn-likert-selected-5 {
  background-color: $grade-ten;
  color: $white;
}
.btn {
  margin-bottom: 5px;
  min-width: 138px;
}
.comment-area {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/likert/index.vue